import React from 'react';
import {path} from './Constant';
class Slider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            'data': props.data.result
        }
    }

    componentDidMount() {
        window.$('.portfolio-slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            adaptiveHeight:true,
               
             //centerMode: true,
            //variableWidth: true,
            // speed: 500,
            cssEase: 'linear',
            useTransform:false,
        });
        window.$('.portfolio-slides').slickLightbox({
            itemSelector: 'a',
            navigateByKeyboard: true
        });
        setTimeout(() => {
            window.$('.portfolio-slides').slick('destroy');
            window.$('.portfolio-slides').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                adaptiveHeight:true,
                //centerMode: true,
                //variableWidth: true,
                // speed: 500,
                 cssEase: 'linear',
                useTransform:false,
            });
            
        }, 1000);
    }

    _makeSliderHtml = () => {
        var html = '';
        html += '<div class="single">';
        html += '<a href="https://clubmiracle.asia/VM/files/villas/' + this.state.data.image.main.image + '">';
        if (this.state.data.image.main.image != null) {
            html += '<img src="https://clubmiracle.asia/VM/files/villas/' + this.state.data.image.main.image + '" alt="Slider1" class="img-fluid w-100 d-block mx-auto"  />';
        } else {
            html += '<img src="'+path+'images/banner1.jpg" alt="Slider1" class="img-fluid w-100 d-block mx-auto" />';
        }
        html += '</a>';
        html += '</div>';
       
        if (Object.values(this.state.data.image.other).length !== 0 && this.state.data.image.other.constructor !== Object) {
              Object.values(this.state.data.image.other).map((value, index) => {
                
                html += '<div class="single">';
                html += '<a href="https://clubmiracle.asia/VM/files/villas/' + value.image + '">';
                html += '<img src="https://clubmiracle.asia/VM/files/villas/' + value.image + '" alt="Slider'+(index+1)+'" class="img-fluid w-100 d-block mx-auto"  />';
                html += '</a>';
                html += '</div>';
             
            });
        } else {
            html += '<div class="single">';
            html += '<a href="'+path+'images/banner2.jpg">';
            html += '<img src="'+path+'images/banner2.jpg" alt="Slider2" class="img-fluid w-100 d-block mx-auto" />';
            html += '</a>';
            html += '</div>';
        }
      
        return { __html: html };
    }

    render() {
        return (
            <React.Fragment>
                <section className="slider mt-5" >
                    <div className="portfolio-slides"  dangerouslySetInnerHTML={this._makeSliderHtml()} />

                    {/* {this._makeSliderHtml()} */}

                </section>
            </React.Fragment>
        );
    }
}

export default Slider;